'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultMessage = undefined;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _getErrorMessage = require('./get-error-message');
var _getErrorMessage2 = _interopRequireDefault(_getErrorMessage);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var defaultMessage = exports.defaultMessage = function defaultMessage(_ref) {
  var number = _ref.number;
  return 'You must enter a number that is at least ' + number + '.';
};
exports.default = function (number) {
  var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMessage;
  return function (value, values) {
    // Throw an error if no number value is passed
    if (number === undefined) throw new TypeError('invalid arguments');
    switch (typeof number === 'undefined' ? 'undefined' : _typeof(number)) {
      case 'number':
        // Throw an error if the number is NaN
        if (isNaN(number)) throw new TypeError('invalid arguments');
        // Compare the values
        return parseFloat(value) >= parseFloat(number) ? '' : (0, _getErrorMessage2.default)(errorMessage, {
          number: parseFloat(number),
          value: parseFloat(value)
        });
      default:
        // If the number paramater is not a number or string then throw a type error
        throw new TypeError('invalid arguments');
    }
  };
};